let newsList;
export default newsList = [
  {
    newsId: 1,
    lavel: 'company',
    lavelData: '会社情報',
    date: '2023年11月',
    title: 'ホームページ開設',
    content: 'ホームページ開設しました。',
    content1: 'ホームページ開設しました。',
    imgSrc: '01.jpg'
  },
  {
    newsId: 2,
    lavel: 'company',
    lavelData: '会社情報',
    date: '2023年11月',
    title: 'FAIR Innovation(suzhou)Robot System社の出展サポート致しました。',
    content: 'FAIR Innovation(suzhou)Robot System社の出展サポート致しました。',
    content1: '20231129',
    imgSrc: '0001.jpg',
    imgSrc1: '0002.jpg',
    imgSrc2: '0003.jpg',
    imgSrc3: '0004.jpg',
    imgSrc4: '0005.jpg',
  },
  // {
  //   newsId: 3,
  //   lavel: 'company',
  //   lavelData: '会社情報',
  //   date: '2023年11月',
  //   title: '○○展示会に出展',
  //   content: '20231129　物流自動化ソリューション、Lowコードソリューションを○○展示会に出展しました。',
  //   content1: '20231129',
  //   imgSrc: '03.jpg'
  // }
]



//////////////////
// WEBPACK FOOTER
// ./static/js/news-list.js
// module id = 0D4D
// module chunks = 1